export enum CalculationMethod {
    Net = 'Net',
    Gross = 'Gross',
    Margin = 'Margin',
    Manual = 'Manual'
}
